module.exports = __webpack_public_path__ + "media/images/blue_checkmark-91a7399e.png";